﻿export class SerialNumberListModel {
    searchText: string = '';
    serialNumber: string = '';
    orderByPropertyId = 0;
    isAscendingSort: boolean = true;
    skipCount: number = 0;
    productCategory: number | null = 0;
}
